import { useStore } from "vuex"
import axiosInstance from "@/api/axios"

// 定義 Bridge 介面
interface WebViewJavascriptBridge {
  callHandler: (handlerName: string, data?: unknown) => void
}

// 擴展 Window 介面以支援 WebViewJavascriptBridge 相關屬性
declare global {
  interface Window {
    WebViewJavascriptBridge?: WebViewJavascriptBridge
    WVJBCallbacks?: Array<(bridge: WebViewJavascriptBridge) => void>
    getMessage?: (params: string) => void
  }
}

const setupWebViewJavascriptBridge = (
  callback: (bridge: WebViewJavascriptBridge) => void
) => {
  if (window.WebViewJavascriptBridge) {
    return callback(window.WebViewJavascriptBridge)
  }
  if (window.WVJBCallbacks) {
    return window.WVJBCallbacks.push(callback)
  }
  window.WVJBCallbacks = [callback]
  const WVJBIframe = document.createElement("iframe")
  WVJBIframe.style.display = "none"
  WVJBIframe.src = "https://__bridge_loaded__"
  document.documentElement.appendChild(WVJBIframe)
  setTimeout(() => {
    document.documentElement.removeChild(WVJBIframe)
  }, 0)

  return undefined
}

// 發送訊息到 APP
export const sendMessage = (message: string) => {
  // iOS
  setupWebViewJavascriptBridge((bridge: WebViewJavascriptBridge) => {
    bridge.callHandler("ObjC Echo", message)
  })

  // Android 使用 console 溝通
  console.log(message)
}

export default function useBridge() {
  const registerGetMessage = () => {
    const websiteInfoStore = useWebsiteInfoStore()
    // 從 APP 取得訊息
    window.getMessage = (params: string) => {
      const message = JSON.parse(params) || {}
      const { "App-Name": AppName = "" } = message
      websiteInfoStore.updateIsApp(true)

      if (AppName) {
        axiosInstance.defaults.headers.common["App-Name"] = AppName
      }
    }
  }

  registerGetMessage()
}
